import { Modal, Button, Group, Stack } from "@mantine/core";
import { useForm } from "react-hook-form";
import { TextInput } from "react-hook-form-mantine";
import { web_upsertInviteRecipientSchema } from "@congrs/schemas";
import resolver from "@congrs/resolver";
import {
  useAddInviteRecipient,
  useUpdateInviteRecipient,
} from "../../../api/invites";

// Shared add/edit modal. When `recipient` is null it adds a new row, otherwise
// it edits the existing one. Email/firstName/lastName are the only editable
// fields (status is system-managed).
const EditRecipientModal = ({ opened, onClose, eventId, recipient }) => {
  const isEdit = !!recipient;

  const { control, handleSubmit, reset } = useForm({
    values: {
      email: recipient?.email || "",
      firstName: recipient?.firstName || "",
      lastName: recipient?.lastName || "",
    },
    resolver: resolver(web_upsertInviteRecipientSchema),
  });

  const { mutate: addRecipient, isPending: isAdding } =
    useAddInviteRecipient(eventId);
  const { mutate: updateRecipient, isPending: isUpdating } =
    useUpdateInviteRecipient({ eventId, id: recipient?.id });

  const handleClose = () => {
    reset({ email: "", firstName: "", lastName: "" });
    onClose();
  };

  const onSubmit = (data) => {
    const payload = {
      email: data.email,
      firstName: data.firstName || null,
      lastName: data.lastName || null,
    };
    const mutation = isEdit ? updateRecipient : addRecipient;
    mutation(payload, { onSuccess: handleClose });
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={isEdit ? "Edit recipient" : "Add recipient"}
      centered
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack gap="sm">
          <TextInput
            label="Email"
            name="email"
            control={control}
            placeholder="name@example.com"
            withAsterisk
          />
          <TextInput
            label="First name"
            name="firstName"
            control={control}
            placeholder="Jane"
          />
          <TextInput
            label="Last name"
            name="lastName"
            control={control}
            placeholder="Doe"
          />
          <Group justify="flex-end" mt="sm">
            <Button variant="default" onClick={handleClose}>
              Cancel
            </Button>
            <Button type="submit" loading={isAdding || isUpdating}>
              {isEdit ? "Save" : "Add"}
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
};

export default EditRecipientModal;
